import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { InternalPressureProfileType, CasingFullOfGasIPP } from '../../models/internal-pressure-profile.model';
import { UomQuantityInput } from '../../uom-quantity-input/uom-quantity-input-component'
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { PoreFrac } from 'src/app/perivis/models/poreFrac.model';
import { WellComponent } from 'src/app/wellbore-inputs/components/well-configuration/models';
import { InfluxFracDepthBaseComponent } from '../gas-influx/influx-frac-depth-base/influx-frac-depth-base.component';

interface CasingFullOfGasForm {
  type: InternalPressureProfileType.CFOG;
  influxDepth: UomQuantityInput;
  porePressure: UomQuantityInput;
  marginOfError: UomQuantityInput;
  gasGradient: UomQuantityInput;
  fractureDepth: UomQuantityInput;
  fractureGradient: UomQuantityInput;
  fractureMarginOfError: UomQuantityInput;
  useGasGravity: boolean;
  gasGravity: UomQuantityInput;
}

@Component({
  selector: 'app-casing-full-of-gas-ipp',
  templateUrl: './casing-full-of-gas-ipp.component.html',
  providers: subformComponentProviders(CasingFullOfGasIppComponent),
  standalone: false
})
export class CasingFullOfGasIppComponent implements AfterViewInit {
  @Input() userUnits: UserUnitsModel;
  @Input() currentString: any;
  @Input() fracPressures: PoreFrac[];
  @Input() porePressures: PoreFrac[];
  @Input() influxDepthRange: { min: number, max: number };
  @Input() fractureDepthDefault: number;
  @Input() tubulars: WellComponent[];

  private _influxFracDepthBase?: InfluxFracDepthBaseComponent;

  @ViewChild(InfluxFracDepthBaseComponent) set influxFracDepthBaseSetter(component: InfluxFracDepthBaseComponent) {
    if (!component) return;

    this._influxFracDepthBase = component;

    if (this.influxDepthRange) {
      component.getEmwDefaultFrac(this.influxDepthRange.max, component.fractureDepthDefault, false, false);
    }
  }

  public form = createForm<CasingFullOfGasIPP, CasingFullOfGasForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.CFOG),
      influxDepth: new UntypedFormControl(null),
      porePressure: new UntypedFormControl(null),
      marginOfError: new UntypedFormControl(null),
      gasGradient: new UntypedFormControl(null),
      fractureDepth: new UntypedFormControl(null),
      fractureGradient: new UntypedFormControl(null),
      fractureMarginOfError: new UntypedFormControl(null),
      useGasGravity: new UntypedFormControl(false),
      gasGravity: new UntypedFormControl(null)
    },
    toFormGroup: (obj: CasingFullOfGasIPP | null): CasingFullOfGasForm | null => {
      if (!obj) {
        return null;
      }

      return {
        type: obj.type,
        influxDepth: { control: obj.influxDepth },
        porePressure: { control: obj.porePressure },
        marginOfError: { control: obj.marginOfError },
        gasGradient: { control: obj.gasGradient },
        fractureDepth: { control: obj.fractureDepth },
        fractureGradient: { control: obj.fractureGradient },
        fractureMarginOfError: { control: obj.fractureMarginOfError },
        useGasGravity: obj.useGasGravity,
        gasGravity: { control: obj.gasGravity }
      };
    },
    fromFormGroup: (formValue: CasingFullOfGasForm): CasingFullOfGasIPP | null => {
      const { influxDepth, porePressure, marginOfError, gasGradient, fractureDepth, fractureGradient, fractureMarginOfError, gasGravity, ...commonValues } = formValue;

      return {
        influxDepth: +influxDepth?.control,
        porePressure: +porePressure?.control,
        marginOfError: +marginOfError?.control,
        gasGradient: +gasGradient?.control,
        fractureDepth: +fractureDepth?.control,
        fractureGradient: +fractureGradient?.control,
        fractureMarginOfError: +fractureMarginOfError?.control,
        gasGravity: +gasGravity?.control,
        ...commonValues
      };
    }
  });

  ngAfterViewInit(): void {
      this._influxFracDepthBase.gasGravityChange();
  }
}
